module.exports = __webpack_public_path__ + "img/appIcon-menu-User.44c96faa.svg";